// store/consensusSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    consensusData: {}, // store consensus keyed by index or monthYear
    checkedRows: {}, // store checkbox state keyed by index
};

const consensusSlice = createSlice({
    name: 'consensus',
    initialState,
    reducers: {
        setConsensusValue: (state, action) => {
            const { index, monthYear, consensus } = action.payload;
            state.consensusData[index] = { monthYear, consensus };
        },
        setMultipleConsensusValues: (state, action) => {
            const { values } = action.payload;
            values.forEach(({ index, monthYear, consensus }) => {
                state.consensusData[index] = { monthYear, consensus };
            });
        },
        setRowChecked: (state, action) => {
            const { index, checked } = action.payload;
            state.checkedRows[index] = checked;
        },
        // Optional: clear/reset state
        resetConsensusData: (state) => {
            state.consensusData = {};
            state.checkedRows = {};
        }
    },
});

export const { setConsensusValue, setMultipleConsensusValues, setRowChecked, resetConsensusData } = consensusSlice.actions;

export default consensusSlice.reducer;


